var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-dialog',{ref:"form-saveas",attrs:{"title":"另存为模板","data":_vm.data,"width":"80%","visible":_vm.visibleSync,"columns":_vm.columnList},on:{"update:visible":function($event){_vm.visibleSync=$event},"confirm":_vm.SaveAs}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a3888b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dictionary/NarcoticsBox/SaveAs.vue
// module id = null
// module chunks = 